import { autoinject, PLATFORM } from 'aurelia-framework';
import {
	ClassicPanelDialog,
	ClassicPanelDialogModel,
	ClassicPanelDialogModelDefaults,
} from '~/components/classic-panel/classic-panel-dialog';
import { BaseDialog } from '~/components/dialog/base-dialog';
import { FormType } from '~/components/form/form';
import { RedemptionFields } from '~/forms/benefits-payments-centre/redemption-fields/redemption-fields';
import { FormModel, Modifiable } from '~/models/form-model';
import FormModelUtils from '~/utils/form-model-utils';
import { Notification } from '~/components/notification/notification';

export interface RedemptionInputsDialogModel extends ClassicPanelDialogModel {
	batchRef?: string;
	fund?: string;
	member?: string;
}

const RedemptionInputsDialogModelDefaults: RedemptionInputsDialogModel = {
	...ClassicPanelDialogModelDefaults,
	cancelButtonText: 'clickable-elements.close',
	dialogSize: BaseDialog.DialogSize.LARGE,
};

@autoinject
export class RedemptionInputsDialog extends ClassicPanelDialog<RedemptionInputsDialogModel> {
	constructor(...rest) {
		super(...rest);
		PLATFORM.moduleName('./redemption-inputs-dialog');
	}

	public activate(
		model: RedemptionInputsDialogModel,
	): Promise<RedemptionInputsDialogModel> {
		return super.activate(model, RedemptionInputsDialogModelDefaults);
	}

	public attached(): void {
		super.attached();
		if (this.model.formType === FormType.ADD) {
			if (this.classicPanel.formModel) {
				const preInsertFormModel = FormModelUtils.cloneModel(
					this.classicPanel.formModel,
				);
				preInsertFormModel.fields.T4z_Fund.value = this.model.fund;
				preInsertFormModel.fields.T4z_Fund.modifiable =
					Modifiable.FALSE;
				preInsertFormModel.fields.T4z_Member.value = this.model.member;
				preInsertFormModel.fields.T4z_Member.modifiable =
					Modifiable.FALSE;
				this.classicPanel.formModel = preInsertFormModel;
				this.classicPanel.setIsEditing(true);
			}
		} else {
			this.classicPanel.setIsEditing(true);
		}
	}

	public edit(): void {
		this.classicPanel.setIsEditing(true);
	}

	public cancelEditOrClose(): void {
		if (!this.classicPanel.isInEditMode) {
			this.close();
			return;
		}

		this.classicPanel
			.promptToClosePanelIfChangedAndClearValidation()
			.then(() => this.classicPanel.setIsEditing(false));
	}

	protected formModelChanged(
		formModel: FormModel,
		oldFormModel: FormModel,
	): void {
		super.formModelChanged(formModel, oldFormModel);
	}

	/**
	 * @override
	 */
	protected preLoadClassicPanelFormModelData(): Promise<void> {
		if (!this.model || !this.model.functionName) {
			throw new Error(
				'RedemptionInputsDialogModel or functionName are missing!',
			);
		}
		return (
			this.getClassicPanelPreInsertFormModelPromise(
				this.model.functionName,
			)
				.then((model) => {
					this.preLoadedFormModel = this.setAdditionalFilters(model);
				})
				// Show an error and abort navigation
				.catch((error) => {
					Notification.error(error.message || error.error || error);
					return Promise.reject(error);
				})
		);
	}
}
